import type { RouteRecordRaw, RouteLocationNormalized, LocationQueryValue } from 'vue-router'
import DemandeEnLigne from '../components/del/DemandeEnLigne.vue'

function getLangueFromCulture(culture: LocationQueryValue | LocationQueryValue[]) {
    if (!culture) return 'fr'

    const specifiedCulture = (culture as LocationQueryValue) ?? culture[0]
    return specifiedCulture!.substring(0, 2)
}

export default [
    {
        path: '/del/formulaire',
        name: 'del_formulaire',
        component: DemandeEnLigne,
        props: (route: RouteLocationNormalized) => ({ c: route.query.c, noSuccursale: route.query.noSuccursale, langue: route.query.langue ?? 'fr' }),
    },
    {
        path: '/Home/Index',
        name: 'del_home_index',
        component: DemandeEnLigne,
        props: (route: RouteLocationNormalized) => ({
            c: route.query.c,
            noSuccursale: route.query.noSuccursale,
            langue: getLangueFromCulture(route.query.culture),
        }),
    },
] as RouteRecordRaw[]
